import { FiBell, FiSearch, FiChevronDown, FiUser, FiSettings, FiLogOut, FiHelpCircle, FiMenu } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import './Header.css';
import { useState, useEffect, useRef } from 'react';
const PAGE_TITLES = {
  dashboard:    'Dashboard',
  books:        'Books',
  members:      'Members',
  'issue-return': 'Issue & Return',
  collection:   'Collections',
  reports:      'Reports',
  users:        'User Management',
  profile:      'My Profile',
  help:         'Help Center',
  settings:     'Settings',
};

const Header = ({ activePage, onNavigate, onToggleSidebar }) => {
  const { user, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const pageTitle = PAGE_TITLES[activePage] || 'Dashboard';

  return (
    <header className="header">
      {/* ── Left: Title ── */}
      <div className="header__left">
        <button className="header__menu-toggle" onClick={onToggleSidebar} aria-label="Toggle Menu">
          <FiMenu />
        </button>
        <div className="header__breadcrumb">
          <span className="header__breadcrumb-root">LMS</span>
          <span className="header__breadcrumb-sep">/</span>
          <span className="header__breadcrumb-current">{pageTitle}</span>
        </div>
        <h1 className="header__title">{pageTitle}</h1>
      </div>

      {/* ── Right: Actions ── */}
      <div className="header__right">
        {/* Search */}
        {/* <div className="shared-search-box header__search">
          <FiSearch className="shared-search-box__icon" />
          <input
            type="text"
            placeholder="Quick search books or members…"
            className="shared-search-box__input"
            aria-label="Quick search"
          />
          <span className="header__search-kbd">⌘K</span>
        </div> */}

        {/* Notification */}
        {/* <button className="header__icon-btn" aria-label="Notifications (3 unread)">
          <FiBell />
          <span className="header__notif-badge" aria-hidden="true">3</span>
        </button> */}

        {/* User Dropdown */}
        <div className="header__user" ref={dropdownRef}>
          <button
            className="header__user-trigger"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
            id="user-menu-trigger"
          >
            <div className="header__avatar" aria-hidden="true">{user?.name?.charAt(0) || user?.username?.charAt(0)}</div>
            <div className="header__user-info">
              <span className="header__user-name">{user?.name || user?.username}</span>
              <span className="header__user-role">{user?.role || 'Staff'}</span>
            </div>
            <FiChevronDown className={`header__chevron ${dropdownOpen ? 'header__chevron--open' : ''}`} />
          </button>

          {dropdownOpen && (
            <div className="header__dropdown" role="menu" aria-labelledby="user-menu-trigger">
              <div className="header__dropdown-header">
                <div className="header__dropdown-avatar">{user?.name?.charAt(0) || user?.username?.charAt(0)}</div>
                <div>
                  <p className="header__dropdown-name">{user?.name || user?.username}</p>
                  <p className="header__dropdown-email">{user?.username}@library.com</p>
                </div>
              </div>
              <div className="header__dropdown-divider" />
              <ul className="header__dropdown-menu">
                {[
                  { icon: <FiUser />,     label: 'My Profile',  page: 'profile' },
                  { icon: <FiSettings />, label: 'Settings',    page: 'settings' },
                  { icon: <FiHelpCircle />, label: 'Help Center', page: 'help' },
                ].map((item) => (
                  <li key={item.label}>
                    <button className="header__dropdown-item" role="menuitem" onClick={() => {onNavigate(item.page); setDropdownOpen(false);}}>
                      <span className="header__dropdown-item-icon">{item.icon}</span>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
              <div className="header__dropdown-divider" />
              <button className="header__dropdown-item header__dropdown-item--danger" role="menuitem" onClick={logout}>
                <span className="header__dropdown-item-icon"><FiLogOut /></span>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
